import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataImportsConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  loadDataImportXlsReport(userId: string, dataImportId: string): Observable<Blob> {
    return this.httpClient.get(
      this.occEndpointsService.buildUrl('dataImportXlsReport', {
        urlParams: {
          userId,
          dataImportId,
        },
      }),
      {
        responseType: 'blob',
      }
    );
  }
}
